module.exports = __webpack_public_path__ + "img/PLUS.77c02ded.svg";